import { Box, Paper, Typography } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import type { ColDef } from "ag-grid-community";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import "../../../assets/css/AGGrid-custom.css";

ModuleRegistry.registerModules([AllCommunityModule]);

type PipelineSummaryTableProps = {
  title: string;
  rowData: Record<string, unknown>[];
  columnDefs: ColDef[];
  minHeight: number;
  dealCount: number;
};

export function PipelineSummaryTable({
  title,
  rowData,
  columnDefs,
  minHeight,
  dealCount,
}: PipelineSummaryTableProps) {
  return (
    <Paper
      elevation={0}
      sx={{
        width: "100%",
        height: "100%",
        minHeight,
        display: "flex",
        flexDirection: "column",
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2,
        background:
          "linear-gradient(180deg, #FAFBFC 0%, #FFFFFF 28%, #FFFFFF 100%)",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          px: { xs: 2, md: 2.5 },
          py: 2,
          borderBottom: "1px solid",
          borderColor: "divider",
          display: "flex",
          alignItems: "baseline",
          justifyContent: "space-between",
          gap: 2,
          flexShrink: 0,
        }}
      >
        <Typography className="text-general-section-title">
          {title}
        </Typography>
        <Typography sx={{ fontSize: 12, color: "text.secondary" }}>
          <Box component="span" sx={{ fontWeight: 700, color: "#182737" }}>
            {dealCount}
          </Box>{" "}
          deals
        </Typography>
      </Box>

      <Box sx={{ flex: 1, minHeight: 0, px: { xs: 1.5, md: 2 }, py: 1.5 }}>
        <div className="ag-theme-alpine" style={{ width: "100%" }}>
          <AgGridReact
            rowData={rowData}
            columnDefs={columnDefs}
            defaultColDef={{
              flex: 0,
              resizable: false,
              filter: false,
              sortable: false,
            }}
            rowHeight={30}
            headerHeight={30}
            suppressCellFocus={true}
            domLayout="autoHeight"
            suppressHorizontalScroll={true}
            suppressScrollOnNewData={true}
          />
        </div>
      </Box>
    </Paper>
  );
}
